import PopupDevicesComponent from "./PopupDevicesComponent";
import * as controller from "./controller";

export default controller;
export { PopupDevicesComponent };
